import SEO from "@/components/SEO";
import Marquee from "@/components/Marquee";
import Hero from "@/sections/Hero";
import Recognition from "@/sections/Recognition";
import BookFeature from "@/sections/BookFeature";
import Approach from "@/sections/Approach";
import Pause from "@/sections/Pause";
import BeginHerePreview from "@/sections/BeginHerePreview";
import AboutPreview from "@/sections/AboutPreview";
import Letters from "@/sections/Letters";
import { SEO as SEO_CONTENT } from "@/content";

const HomePage = () => (
  <>
    <SEO title={SEO_CONTENT.home.title} description={SEO_CONTENT.home.description} />
    <Hero />
    <Marquee />
    <Recognition />
    <BookFeature />
    <Approach />
    <Pause />
    <BeginHerePreview />
    <AboutPreview />
    <Letters />
  </>
);

export default HomePage;
